import React from 'react';
import Badge, { type BadgeSize } from './Badge';
import { disposition as dispositionDict } from '@/lib/dict';
import type { Disposition } from '@/lib/api/types';

/**
 * Телефонный исход звонка.
 *
 * Измерение, независимое от статуса обработки: пропущенный звонок — это
 * `no_answer` **и** `skipped` одновременно. Поэтому бейджей два, и сводить
 * их в один нельзя: пропущенные звонки и сбои конвейера — разные вещи,
 * а путать их в отчёте дороже всего.
 */
export default function DispositionBadge({
  disposition,
  size = 'md',
}: {
  disposition: Disposition;
  size?: BadgeSize;
}) {
  const term = dispositionDict[disposition] ?? { label: disposition, tone: 'muted' as const };

  return (
    <Badge tone={term.tone} size={size} title={term.hint}>
      {term.label}
    </Badge>
  );
}
